import { createContext, useState } from 'react';

export const ThemeContext = createContext();

export const ThemeProvider = ({ children }) => {

  //SearchBar text
  const[inputValue, setInputValue] = useState(null);


  //select Reports Filter by category
  const [filterByCategory, setFilterByCategory] = useState(null);
  
  //select Reports Filter Option
  const [selectedFilter, setSelectedFilter] = useState(null);

  //Contact Dialog Box - PopUp
  const [openPopUp, setOpenPopUp] = useState(false);


  return (
    <ThemeContext.Provider value={{ selectedFilter, setSelectedFilter, inputValue, setInputValue, filterByCategory, setFilterByCategory, openPopUp, setOpenPopUp }}>
      {children}
    </ThemeContext.Provider>
  );
};
